import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/context/ConfigContext";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Models from "@/pages/Models";
import Chat from "@/pages/Chat";
import Vision from "@/pages/Vision";
import ImageGeneration from "@/pages/ImageGeneration";
import ImageEdit from "@/pages/ImageEdit";
import VideoGeneration from "@/pages/VideoGeneration";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/models" element={<Models />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/image" element={<ImageGeneration />} />
              <Route path="/edit" element={<ImageEdit />} />
              <Route path="/video" element={<VideoGeneration />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </ConfigProvider>
    </div>
  );
}

export default App;
